import React from 'react';
import { Bot, Layers, Sparkles, Cpu } from 'lucide-react';

export default function AgenticEraSection() {
  return (
    <section className="relative py-24 bg-white dark:bg-[#0B0F19] overflow-hidden">
      {/* Optional Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-blue-500/10 dark:bg-blue-600/20 blur-[100px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-sm font-semibold mb-6">
            <Sparkles className="w-4 h-4" />
            <span>The Future of Computing</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6 tracking-tight">
            Entering the <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-500">Agentic Era</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 leading-relaxed">
            The way we interact with technology could change dramatically over the next two years. Autonomous agents are becoming the new interface for everyday computing.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Card 1 */}
          <div className="p-8 rounded-2xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/50 hover:shadow-lg transition-shadow duration-300">
            <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400 rounded-xl flex items-center justify-center mb-6">
              <Bot className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
              Mainstream by 2027
            </h3>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
              Highly capable AI assistants and agents will be able to perform many tasks currently done across smartphones and computers.
            </p>
          </div>

          {/* Card 2 */}
          <div className="p-8 rounded-2xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/50 hover:shadow-lg transition-shadow duration-300">
            <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900/50 text-purple-600 dark:text-purple-400 rounded-xl flex items-center justify-center mb-6">
              <Layers className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
              Deep OS Integration
            </h3>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
              Users could increasingly delegate complex, multi-step tasks to personal AI agents, with operating systems eventually giving trusted agents deeper access.
            </p>
          </div>
        </div>

        {/* MNR Highlight Banner */}
        <div className="relative rounded-3xl p-[1px] bg-gradient-to-r from-blue-500 via-purple-500 to-blue-500 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-blue-500 animate-[spin_4s_linear_infinite] opacity-50 blur-lg" />
          <div className="relative bg-white dark:bg-gray-900 rounded-[23px] p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 justify-between">
            <div className="max-w-2xl">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-3">
                <Cpu className="w-8 h-8 text-blue-500" />
                MNR is Already Here
              </h3>
              <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
                MNR has been in the agentic era for years. We have worked on hundreds of real use cases and deployed our AI agents to work autonomously, entirely industry-agnostic.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}